import {Separator} from '@common-web/components/ui/separator';
import {useFormContext} from 'react-hook-form';
import {ContactFields} from '../components/ContactFields';
import {CopyFromSection125} from '../components/CopyFromSection125';

export function MecContacts({disableFormCopy}: {disableFormCopy?: boolean}) {
  const {getValues, setValue} = useFormContext();
  const copyFromSection125 = () => {
    const src = getValues('section125Form.contacts');
    if (src) {
      setValue('mecForm.contacts', src, {shouldDirty: true, shouldValidate: true});
    }
  };

  return (
    <div className='space-y-6'>
      {!disableFormCopy && <CopyFromSection125 onCopy={copyFromSection125} />}
      <div>
        <ContactFields
          basePath={'mecForm.contacts.authorizedSigner'}
          titlePrefix={'Authorized Signer (Plan Administrator)'}
          requiredFields={['firstName', 'lastName', 'email']}
          copySources={[
            {label: 'Eligibility Contact', path: 'mecForm.contacts.eligibilityContact'},
            {label: 'Billing Contact', path: 'mecForm.contacts.billingContact'},
          ]}
        />
      </div>
      <Separator />
      <div>
        <ContactFields
          basePath={'mecForm.contacts.eligibilityContact'}
          titlePrefix={'Eligibility Contact (Optional)'}
          copySources={[
            {
              label: 'Same as Plan Administrator (Authorized Signer)',
              path: 'mecForm.contacts.authorizedSigner',
            },
            {label: 'Billing Contact', path: 'mecForm.contacts.billingContact'},
          ]}
        />
      </div>
      <Separator />
      <div>
        <ContactFields
          basePath={'mecForm.contacts.billingContact'}
          titlePrefix={'Billing Contact'}
          requiredFields={['firstName', 'lastName', 'email']}
          copySources={[
            {
              label: 'Same as Plan Administrator (Authorized Signer)',
              path: 'mecForm.contacts.authorizedSigner',
            },
            {label: 'Eligibility Contact', path: 'mecForm.contacts.eligibilityContact'},
          ]}
        />
      </div>
    </div>
  );
}
